import ToolToggleBlock from './ToolToggleBlock';

class ToolToggleQuote extends ToolToggleBlock {
  static toolName = 'Quote';
  static iconClass = 'fa-regular fa-quote-right';
  static blockType = 'quote';
}

export default ToolToggleQuote;
